<template>
  <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10 align-self-center">
          <h2>{{ $t('navigations.subject dashboard')}}</h2>
      </div>

  </div>
  <div class="wrapper wrapper-content">
    <div class="row">  
      <div class="col-lg-3 mb-1 pr-0 pl-1">
        <div class="dash-widget cursor-pointer " @click.prevent="$router.push('/submitForm')">
            <div class="row">
              <div class="col-8 text-left">
                  <span> <h4>{{ $t('navigations.assigned visits')}}</h4></span>
                      <h1 class="font-bold">{{totalvisits}}</h1>
              </div>
              <div class="col-4 justify-content-center align-self-center">
                  <img src="../../assets/img/db_newforms.png" alt="New Forms">
              </div>
            </div>
        </div>
      </div>  

      <div class="col-lg-3 mb-1 pr-0 pl-1">
        <div class="dash-widget cursor-pointer" @click.prevent="$router.push('/submitForm')">
            <div class="row">
              <div class="col-8 text-left">
                  <span> <h4>{{ $t('navigations.overdue visits')}}</h4></span>
                      <h1 class="font-bold">{{overduevisitcount}}</h1>
              </div>
              <div class="col-4 justify-content-center align-self-center">
                  <img src="../../assets/img/db_open_queries.png" alt="New Forms">
              </div>
            </div>
        </div>
      </div> 

      <div class="col-lg-3 mb-1 pr-0 pl-1">
        <div class="dash-widget cursor-pointer" @click.prevent="$router.push('/submitForm')">
            <div class="row">
              <div class="col-8 text-left">
                  <span> <h4>{{ $t('navigations.completed visits')}}</h4></span>
                      <h1 class="font-bold">{{completedvisitcount}}</h1>
              </div>
              <div class="col-4 justify-content-center align-self-center">
                  <img src="../../assets/img/db_totalsites.png" alt="New Forms">
              </div>
            </div>
        </div>
      </div> 

      <div class="col-lg-3 mb-1 pr-0 pl-1">
        <div class="dash-widget cursor-pointer" @click.prevent="$router.push('/listform')">
            <div class="row">
              <div class="col-8 text-left">
                  <span> <h4>{{ $t('navigations.submitted forms')}}</h4></span>
                      <h1 class="font-bold">{{submittedforms}}</h1>
              </div>
              <div class="col-4 justify-content-center align-self-center">
                  <img src="../../assets/img/db_totalsubjects.png" alt="New Forms">
              </div>
            </div>
        </div>
      </div> 
      <div class="col-lg-12 pr-0 pl-1">
            <div class="ibox-body">
                <div class="ibox-title style_2 d-flex justify-content-between py-1">
                  <h5 class="mt-2">{{ $t('navigations.Real-Time Subject Schedule Overview')}}</h5>
                  <div class="col-md-3 d-flex">
<label class="mt-auto col-md-5 mb-auto mr-1">Select Layout</label>
       <div class="mt-2 ">
         <select class="form-select py-1" v-model="selectedLayout">
           <option value="dagre">Dagre</option>
           <option value="breadthfirst">Breadthfirst</option>
           <option value="grid">Grid</option>
           <!-- <option value="circle">Circle</option>
           <option value="concentric">Concentric</option> -->
           <option value="cose">Cose</option>
           <!-- <option value="klay">Klay</option> -->
         </select>
       </div>
       <div class="m-2">
             <a v-if="selectedorientation=='LR'" @click="selectedorientation = 'TB',layouconfigchange()" class="close-link" title="Horizontal Layout">
               <img src="../../assets/images/orientation_Horizontal.svg" alt="Orientation" style="width: 26px; height: 26px"/>
             </a>
             <a v-if="selectedorientation=='TB'" @click="selectedorientation = 'LR',layouconfigchange()" class="close-link" title="Vertical Layout">
               <img src="../../assets/images/orientation_Vertical.svg" alt="Orientation" style="width: 26px; height: 26px"/>
             </a>
       </div>
       </div>
                </div>
                <div class="ibox-content" style="min-height:200px">
                   <div class="d-flex totalborder">
        <graph v-show="!spinner" ref="childComp" class="col-md-10" :customlabels="customlabel"
          :selectedpatientid="selectedpatient" @showsitegraph="showsitegraph" @showsubjectgraph="showsubjectgraph"
          @changevisitstatusmodel="changevisitstatusmodel" :collapsedtypes="collapsedtypes" :graphdata="graphdata"
          :selectedLayout="selectedLayout" :menuitems="menuitems" @showproperties="showproperties"
          @uncheduledvisit="openunscheduledvisitModal" @showformmodel="showformmodel" />
      
        <div v-if="Object.keys(graphdata).length != 0 && !spinner" class="col-md-2 p-4">
          <!-- Legend Items -->
          <div v-for="(item, key) in legendStatus" :key="key">
            <div v-if="typeArray.includes(key)" @mouseover="showPopup(key, $event)" @mouseleave="hidePopup"
              class="d-flex justify-content-between border-bottom mb-2 pb-1 legend-item">
              <span class="mr-2">{{ key }}:</span>
              <img :src="require(`@/assets/images/GraphShapes/${getIconName(key)}.svg`)" alt="Shape"
                class="legandicon" />
            </div>
          </div>

          <!-- Popup Template -->
          <div v-if="popup.show" class="status-popup" :style="{ left: popup.x + 'px', top: popup.y + 'px' }">
            <div v-for="status in legendStatus[popup.type]" :key="status.label" class="status-item">
              <div class="color-circle" :style="{ backgroundColor: status.color }"></div>
              <span class="status-label">{{ status.label }}</span>
            </div>
          </div>
        </div>

      </div>
      <div v-if="spinner" class="d-flex justify-content-center align-items-center spinnerborder" style="height:600px;">
  <div class="spinner-border text-primary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
                </div>
            </div>
        </div>


    </div>
    
  </div>
  <showformmodel
  v-if="setshowFormModal"
    :formid="currentform"
    :currentformstatus="currentformstatus"
    @closeformModal="closeformModal()"
  />
  <!-- Popup Details Modal -->
  <div v-if="detailspopup" class="modal-wrapper is-visible">
         <div class="modal-container">
          <div class="titleclass">
            <h4 class="px-3 mt-1">Details</h4>
            <div class="closebutton mt-1">
              <a style="color: white" class="close-link">
                <i class="fa fa-times" @click.prevent="closedetailsModal"></i>
              </a>
            </div>
          </div>
          <div class="modelbody p-0">
            <div class="mb-3 p-2">
              <div class="form-group">
                <div class="d-flex flex-column flex-lg-row">
                  <div class="col-lg-12 my-2">
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th>Key</th>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, key) in nodeproperties" :key="key">
                          <td>{{ dictionaryfordetails[key]?dictionaryfordetails[key]:key }}</td>
                          <td>{{ value }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="d-flex justify-content-center my-3">
                  <button class="save_btn py-1 px-4" @click="closedetailsModal">
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
         </div>
        </div>
</template>
<script src="./subject_dashboard.js"></script>
<style scoped>
.widget {
  margin-top: 0rem;
  margin-bottom: 0rem;
}
.widgetmargin {
  margin-top: -13px !important;
}

.style1 {
  background-color: black !important;
  color: #ffffff;
}
.btn-view {
  color: #fff !important;
  background-color: #bb458f !important;
  border-color: #bb458f !important;
}
.btn-view:hover {
  color: #fff;
  background-color: #666ccb;
  border-color: #666ccb;
}
.btn-view:active {
  color: rgb(255, 255, 255) !important;
  background-color: #dda2c7 !important;
  border-color: #dda2c7 !important;
}

.titlemsg {
  border-color: #e7eaec;
  margin-bottom: 0;
  padding: 20px 20px;
  position: relative;
  clear: both;
  right: 0;
  margin-right: 0px;
  margin-left: 0px !important;
  margin-top: 0px !important;
  padding-left: 10px;
}
.padding_bottom {
  padding-bottom: 2rem;
}
.ibox-title h5 {
  height: 0rem;
  padding: 0rem;
}
.ibox-title h5:hover {
  background-color: inherit;
  padding: 0;
  cursor: not-allowed;
}
.titlemsg {
  font-size: 15px;
  font-weight: bold;
  color: var(--primary-color);
}
.switchbtn {
  background-color: #bb458f !important;
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
}
.switchbtn:active {
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
  background-color: #bb458f;
}
.switchbtn:hover {
  height: max-content;
  border-color: #bb458f !important;
  color: white !important;
  float: right;
  background-color: #bb458f;
}
.queryhover:hover {
  color: #3c4192 !important;
  -webkit-transition: color ease-in 400ms;
  transition: color ease-in 400ms;
  cursor: pointer;
}

.widgetminheight {
  min-height: 102px;
}
.graphbutton{
width: fit-content;
padding: 3px;
cursor:pointer;
}
.graphbtncontainer{
display: flex;
gap: 5px;
}
img{
  margin-left: 0px !important;
}
.selectdefault{
  left: 0;
}
.btn:focus {
  outline: none;
  box-shadow: none;
}
.btn-setdefault {
  position: relative;
  padding:0.2rem 0.4rem;
  text-align: center;
  font-size:0.7rem;
  background-color: #ec4758;
  color: white !important;
  border-radius:3px;
}
.ibox-content h1{
  font-weight:400;
  color:#676a6c
}
.color-circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}
.status-popup {
  position: fixed;
  /* Changed from absolute to fixed */
  background: white;
  border: 1px solid #ddd;
  padding: 12px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: 160px;
  /* Fixed width */
  left: 0;
  /* Will be overridden by inline style */
  top: 0;
  /* Will be overridden by inline style */
}

.status-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0;
}

.status-label {
  font-size: 0.85rem;
  color: #333;
}
.spinnerborder{
    border: 1px solid #ddd;
    border-top: 0px;
  }
.legandicon{
    width: 22px;
    height: 22px;
  }
  .modal-wrapper {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
    pointer-events: auto;
    overflow: hidden;
    z-index: 9999;
  }
  
  .modal-container {
    background: #fff;
    width: 80%;
    max-width: 600px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-in-out;
  }
  .modal-containermaxwidth{
    background: #fff;
    width: 80%;
    max-width: 1000px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-in-out;
  }
  .is-visible {
    opacity: 1;
    pointer-events: auto;
  }
</style>
